module.exports = __webpack_public_path__ + "static/img/office (11).0919dc4c.jpg";